import React from "react";
// import NavigationBar from "../components/NavigationBar";
// import Team from '../components/Team'
import { Helmet } from "react-helmet-async";
import AboutNavBar from "../components/AboutNavBar";
import Footer from "../components/Footer";
import Jobs from "../components/Jobs";
 
function AllJobs() {
  const siteUrl = "https://microcodesoftware.com"; // Base URL
  const pagePath = "/job"; // Dynamic path if needed

  const jsonLd = {
    "@context": "https://schema.org/",
    "@type": "WebSite",
    name: "microcodesoftware",
    url: `${siteUrl}${pagePath}`,
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteUrl}/search?query={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <div>
      <Helmet>
        <title>
          Jobs Microcode Software | Custom Software & Digital Marketing Experts
        </title>
        <meta
          name="description"
          content="Discover Microcode Software—a trusted partner delivering custom software solutions and digital marketing strategies. 10+ years’ experience, 150+ projects, and 60+ happy clients across 20+ industries."
        />
        <meta
          name="keywords"
          content="Microcode Software, About Microcode Software, Custom software development, Digital marketing, Software solutions, IT consulting, Business growth, Software company, Marketing strategy, Tech solutions, Software experts"
        />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${siteUrl}${pagePath}`} />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      
      <AboutNavBar />
      <Jobs/>
      <Footer />
      {/* <RenderLinks /> */}
    </div>
  );
}

export default AllJobs;
